
import request from '@/utils/request'

export function userList(pageNo, pageSize, params) {
  return request({
    url:'/api/admin/unc/user/list',
    method:'get',
    params: {
      ...params,
      pageNo,
      pageSize
    }
  })
}

export function teamList(params) {
  return request({
    url:'/api/admin/unc/user/team/list',
    method:'get',
    params:params
  })
}

export function updateLevel(data) {
  return request({
    url: '/api/admin/unc/user/level/update',
    method: 'post',
    data: data
  })
}

export function updateForbidden(data) {
  return request({
    url: '/api/admin/unc/user/forbidden/update',
    method: 'post',
    data: data
  })
}

//查看上级
export function userPathUp(params) {
  return request({
    url:'/api/admin/unc/user/path/up',
    method:'get',
    params,
  })
}
export function userPathdown(params) {
  return request({
    url:'/api/admin/unc/user/path/down',
    method:'get',
    params,
  })
}
export function rechargeOrderAdd(data) {
  return request({
    url:'/api/admin/unc/recharge/order/add',
    method:'post',
    data,
  })
}
export function passwordUpdate(data) {
  return request({
    url:'/api/admin/password/update',
    method:'post',
    data,
  })
}
export function addressUpadate(data) {
  return request({
    url:'/api/admin/unc/user/address/update',
    method:'post',
    data,
  })
}

export function userLevelUpgradeList(pageNo, pageSize, params) {
  return request({
    url:'/api/admin/unc/level/upgrade/list',
    method:'get',
    params: {
      ...params,
      pageNo,
      pageSize
    }
  })
}

//创建账号
export function userRegister(data) {
  return request({
    url:'/api/admin/unc/user/register',
    method:'post',
    data,
  })
}
//添加订单
export function userOrderAdd(data) {
  return request({
    url:'/api/admin/unc/recharge/order/amount/add',
    method:'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js